import { useFormContext } from 'react-hook-form'

export const useLocationFormContext = () => {
  return useFormContext<any>()
}
